// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"ProgressLoader_backdrop__3GIbQ","note":"ProgressLoader_note__h15SD","progress":"ProgressLoader_progress__3cw_a","icon":"ProgressLoader_icon__3XDHn"};